/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliverFeeWarehouseAmountRespVo
 */
export interface DeliverFeeWarehouseAmountRespVo {
    /**
     * 起始值 三边合 单位cm（韩国国内运费）
     * @type {number}
     * @memberof DeliverFeeWarehouseAmountRespVo
     */
    beginValueCm?: number;
    /**
     * 结束值 三边合 单位cm（韩国国内运费）
     * @type {number}
     * @memberof DeliverFeeWarehouseAmountRespVo
     */
    endValueCm?: number;
    /**
     * 起始值 重量 单位kg（韩国国内运费）
     * @type {number}
     * @memberof DeliverFeeWarehouseAmountRespVo
     */
    beginValueKg?: number;
    /**
     * 结束值 重量 单位kg（韩国国内运费）
     * @type {number}
     * @memberof DeliverFeeWarehouseAmountRespVo
     */
    endValueKg?: number;
    /**
     * 金额
     * @type {number}
     * @memberof DeliverFeeWarehouseAmountRespVo
     */
    amount?: number;
}

/**
 * Check if a given object implements the DeliverFeeWarehouseAmountRespVo interface.
 */
export function instanceOfDeliverFeeWarehouseAmountRespVo(value: object): value is DeliverFeeWarehouseAmountRespVo {
    return true;
}

export function DeliverFeeWarehouseAmountRespVoFromJSON(json: any): DeliverFeeWarehouseAmountRespVo {
    return DeliverFeeWarehouseAmountRespVoFromJSONTyped(json, false);
}

export function DeliverFeeWarehouseAmountRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliverFeeWarehouseAmountRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'beginValueCm': json['beginValueCm'] == null ? undefined : json['beginValueCm'],
        'endValueCm': json['endValueCm'] == null ? undefined : json['endValueCm'],
        'beginValueKg': json['beginValueKg'] == null ? undefined : json['beginValueKg'],
        'endValueKg': json['endValueKg'] == null ? undefined : json['endValueKg'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function DeliverFeeWarehouseAmountRespVoToJSON(json: any): DeliverFeeWarehouseAmountRespVo {
    return DeliverFeeWarehouseAmountRespVoToJSONTyped(json, false);
}

export function DeliverFeeWarehouseAmountRespVoToJSONTyped(value?: DeliverFeeWarehouseAmountRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'beginValueCm': value['beginValueCm'],
        'endValueCm': value['endValueCm'],
        'beginValueKg': value['beginValueKg'],
        'endValueKg': value['endValueKg'],
        'amount': value['amount'],
    };
}

